/**
 * FormInput — antd Input 래퍼 (allowClear 기본 ON).
 *
 * 【역할】
 * - 프레임워크 표준 텍스트 입력 컴포넌트.
 * - allowClear 기본값을 true 로 고정 (프로젝트 공통 UX).
 *
 * 【주요 기능】
 * - antd InputProps 를 그대로 받고 통과 (기본 allowClear만 덮어쓰기).
 *
 * 【Props】
 * - (antd InputProps 전부) — allowClear 기본 true.
 *
 * 【사용 예시】
 * ```tsx
 * <FormInput placeholder="고객명" />
 * ```
 */
import { Input } from 'antd'
import type { InputProps } from 'antd'

/**
 * FormInput — 컴포넌트/함수 (자동 생성된 JSDoc 스텁).
 * @returns 렌더 결과 또는 반환값
 */
export default function FormInput(props: InputProps) {
  const { allowClear, ...rest } = props
  return <Input allowClear={allowClear ?? true} {...rest} />
}
